class e {
  numeric(u, r = null) {
    return r === null ? `/^[0-9]+(${u}?)([0-9]{0,2})?$/` : `/^\\d{1,${r}}$/`;
  }
}
export {
  e as default
};
